<template>
  <NavBar />
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
    <FooterQ />
  </v-app>
</template>
<script>

import NavBar from './components/NavBar.vue';
import FooterQ from './components/footer.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    FooterQ,
  },

}
</script>


<style>
#app {
  margin-top: 60px;
}

h2,
h3,
h4,
h5 {
  border-bottom: 1px solid #4CAF50;
}

.cta_nav {
  color: var(--v-theme-on-background);
  padding: 0.5rem 1rem;
  text-decoration: none;
  font-weight: 600;
}

.cont-info-viewport {
  background: hsla(0, 0%, 0%, 0.75);
  border-radius: 4px;
}

.cont-logos {
  background-color: white;
  border-radius: 4px;
}

.img-rounded {
  border-radius: 4px;
  width: 100%;
}

.img-logos {
  filter: grayscale(1);
}

.icons {
  color: #4CAF50;
}

.title {
  font-size: 76px;
  background: -webkit-linear-gradient(to right, #66BB6A, #009688);
  background: linear-gradient(to right, #66BB6A, #009688);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #4CAF50;
}

.cta_nav.wp_icon {
  color: #4CAF50;
}

@media(max-width:992px) {
  .title {
    font-size: 48px;
  }
}

.v-card-item {
  color: #4CAF50;

}

.v-card-item .v-card-title {
  font-weight: bold !important;
}
</style>
